import { render } from "./WorkloadPreApproveDialog.vue?vue&type=template&id=6b715c8d"
import script from "./WorkloadPreApproveDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadPreApproveDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__